import {ApiClientCommunication} from 'neo-common';

export class ConfigurationResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property NumberFormat - string mask how to format numbers, e.g. (0,00)
     */
    NumberFormat: string;

    /**
     * @property ForceToolEnabled - flag if 'force tool' is enabled
     */
    ForceToolEnabled: boolean;

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/ConfigurationResponse.ts
 **/